<div class="modal-header">
  <h3 class="modal-title">Estimate Posting From Provision
    <i class="fa fa-times pull-right" (click)="cancel()"></i>
    <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px" (click)="minimise=!minimise"></i>
  </h3>
</div>
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <div>Do you want to estimate posting from provision ?</div>
  <div style="margin-top: 15px;">
    <label><strong>Select ME Codes:</strong></label>
    @if (loadingMeCodes) {
<div class="me-code-loader">
      <i class="fa fa-spinner fa-spin"></i> Loading ME Codes...
    </div>
}
    @if (!loadingMeCodes && (!meCodeList || meCodeList.length === 0)) {
<div class="no-me-codes">
      No ME Codes available.
    </div>
}
    @if (!loadingMeCodes && meCodeList && meCodeList.length > 0) {
<div>
      <div class="select-actions">
        <button class="btn btn-xs" type="button" (click)="selectAllMeCodes()"
                [ngClass]="{'btn-info': isAllSelected(), 'btn-default': !isAllSelected()}">
          <i class="fa" [ngClass]="{'fa-check-square-o': isAllSelected(), 'fa-square-o': !isAllSelected()}"></i> Select All
        </button>
        <button class="btn btn-xs" type="button" (click)="unselectAllMeCodes()"
                [ngClass]="{'btn-info': isNoneSelected(), 'btn-default': !isNoneSelected()}">
          <i class="fa" [ngClass]="{'fa-check-square-o': isNoneSelected(), 'fa-square-o': !isNoneSelected()}"></i> Unselect All
        </button>
      </div>
      <div class="me-code-list-container">
        @for (meCode of meCodeList; track $index; let i = $index) {
<div class="me-code-item">
          <input type="checkbox" [id]="'meCode_' + i" [(ngModel)]="meCodeList[i].selected">
          <label [attr.for]="'meCode_' + i">{{ meCode.ME_NAME }}</label>
        </div>
}
      </div>
      <div class="selected-count">
        <i class="fa fa-info-circle"></i>
        {{ getSelectedMeCodesCount() }} of {{ meCodeList.length }} ME Code(s) selected
      </div>
    </div>
}
  </div>
</div>
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm save-button" type="button" (click)="estimatePosting()" [disabled]="getSelectedMeCodesCount() === 0">
    RTP to EST Postings <span>@if (saveloader) {
<i class="fa fa-spinner fa-pulse"></i>
}</span>
  </button>
  <button class="btn btn-danger btn-sm" type="button" (click)="deletePostingsFromEST()" [disabled]="deleteLoader || getSelectedMeCodesCount() === 0">
    Delete Postings from EST <span>@if (deleteLoader) {
<i class="fa fa-spinner fa-pulse"></i>
}</span>
  </button>
  <button class="btn btn-info btn-sm" type="button" (click)="recalculateTotals()" [disabled]="recalcLoader || getSelectedMeCodesCount() === 0">
    Recalculate Totals <span>@if (recalcLoader) {
<i class="fa fa-spinner fa-pulse"></i>
}</span>
  </button>
  <button class="btn btn-warning btn-sm cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
